import React from 'react';
import { connect } from 'react-redux';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import ForgotPassword from '../Components/Login/ForgotPassword';

const ForgotPasswordPage = ({ user, config, cmsSourceFirebase, actions, match }) => {
    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <ForgotPassword />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordPage);
